import { DEFAULT_VIEW, HOLES_VIEW } from '../qual-leaderboard-const';

export const renderClassName = ({
    className, view, r1, r2, qualifyReserveFlag, teeStartPosition
}) => {
    let classNameTable = className || 'qual-leaderboard__table';

    if (view === DEFAULT_VIEW) {
        if (r1 && r2) {
            classNameTable = `${classNameTable}--r`;
            return classNameTable;
        }

        if (teeStartPosition && !qualifyReserveFlag) {
            classNameTable = `${classNameTable}--during`;
            return classNameTable;
        }

        if (teeStartPosition && qualifyReserveFlag) {
            classNameTable = `${classNameTable}--post`;
            return classNameTable;
        }
    }

    if (view === HOLES_VIEW) {
        classNameTable = `${classNameTable}--holebyhole`;
        return classNameTable;
    }

    return '';
};
